import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'empIds',
      type: 'select',
      label: '员工',
      clearable: true,
      filterable: true,
      placeholder: '请选择员工'
    },
    {
      field: 'corpName',
      type: 'select',
      label: '企业',
      clearable: true,
      placeholder: '请选择企业',
      filterable: true,
      options: []
    },
    {
      label: '客户',
      field: 'custName',
      type: 'input',
      placeholder: '请输入客户昵称/名字'
    },
    {
      label: '所处开发阶段',
      field: 'exploitPhase',
      type: 'select',
      clearable: true,
      placeholder: '请选择开发阶段',
      options: [
        { title: '浅营销', value: '浅营销' },
        { title: '转营销', value: '转营销' },
        { title: '营销', value: '营销' },
        { title: '逼单', value: '逼单' },
      ]
    },
    {
      field: 'date',
      type: 'datepicker',
      label: '资源时间',
      clearable: false,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      label: '更新时间',
      field: 'updateDate',
      type: 'select',
      clearable: true,
      placeholder: '请选择更新时间段',
      options: [
        { title: '今天', value: 'today' },
        { title: '昨天', value: 'yesterday' },
        { title: '昨天以前', value: 'before' },
      ]
    },
    {
      label: '是否成交',
      field: 'isEnd',
      type: 'select',
      clearable: true,
      placeholder: '请选择是否成交',
      options: [
        { title: '是', value: '√' },
        { title: '否', value: '' }
      ]
    }
  ]
}
